import { render } from "./menubar.vue?vue&type=template&id=e286fc10"
import script from "./menubar.vue?vue&type=script&lang=js"
export * from "./menubar.vue?vue&type=script&lang=js"

import "./menubar.vue?vue&type=style&index=0&id=e286fc10&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__